var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "deposit detail" },
    [
      _vm.lang == _vm.$config.LANG_KOR
        ? [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(0),
                _vm._m(1),
                true
                  ? _c("div", { staticClass: "summary" }, [_vm._m(2)])
                  : _vm._e()
              ]),
              _vm._m(3)
            ])
          ]
        : [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(4),
                _vm._m(5),
                true
                  ? _c("div", { staticClass: "summary" }, [_vm._m(6)])
                  : _vm._e()
              ]),
              _vm._m(7)
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("정기예금(개인용)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          "목돈을 일정기간동안 예치하여 안정적인 수익을 목적으로 하는 일시예치식 예금"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "text" }, [_vm._v("최대 연")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v("4.80%")]),
      _c("div", { staticClass: "etc" }, [_vm._v("(아래참조)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("상품유형")]),
        _c("dd", [_vm._v("정기예금")]),
        _c("dt", [_vm._v("상품개요")]),
        _c("dd", [
          _vm._v(
            "목돈을 일정기간 동안 예치하여 안정적인 수익을 목적으로 하는 일시예치식 상품"
          )
        ]),
        _c("dt", [_vm._v("가입대상")]),
        _c("dd", [_vm._v("실명의 개인")]),
        _c("dt", [_vm._v("계약기간")]),
        _c("dd", [
          _vm._v(" NZD : 최저 7일 ~ 최장 5년 "),
          _c("br"),
          _vm._v("USD : 31일, 61일, 92일, 183일 (1개월, 2개월, 3개월, 6개월) "),
          _c("br"),
          _c("p", { staticStyle: { color: "red" } }, [
            _vm._v(
              "12개월 초과 정기예적금 상품은 비대면 채널을 통한 가입이 어려우므로 신규를 원하시는 경우 영업점으로 문의 부탁드립니다."
            )
          ])
        ]),
        _c("dt", [_vm._v("가입통화")]),
        _c("dd", [_vm._v("NZD, USD")]),
        _c("dt", [_vm._v("가입금액")]),
        _c("dd", [
          _vm._v(" NZD 5,000.00 이상 "),
          _c("br"),
          _vm._v("USD 5,000.00 이상 ")
        ]),
        _c("dt", [_vm._v("금리 및 이율")]),
        _c("dd", [_vm._v(" 약정이율 "), _c("br"), _vm._v("통화 : NZD ")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(연이율, 세전, 단위 : %)")
      ]),
      _c("table", { staticClass: "table -type03" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [_vm._v("정기예금")]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v(" $5,000 "),
              _c("em", [_vm._v("이상")])
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v(" $10,000 "),
              _c("em", [_vm._v("이상")])
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v(" $50,000 "),
              _c("em", [_vm._v("이상")])
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v(" $100,000 "),
              _c("em", [_vm._v("이상")])
            ])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(" 7D~1M "),
              _c("em", [_vm._v("미만")])
            ]),
            _c("td", [_vm._v(" 0 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 0 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 0 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 0 "), _c("em", [_vm._v(".00")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("1M")]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".10")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("2M")]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".10")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("3M")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".60")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("4M")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".60")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("5M")]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".10")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".10")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".10")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("6M")]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".50")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".60")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".60")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".80")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("9M")]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".40")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".50")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".50")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".60")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("1Y")]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".10")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".30")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("2Y")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("3Y")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("4Y")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("5Y")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])])
          ])
        ])
      ]),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [_vm._v("· 중도해지 : 약정이율 -2% 또는 0%")]),
        _c("p", [_vm._v("· 만기이후이율 : 약정이율 ÷ 2")]),
        _c("p", [
          _vm._v(
            "· 모든 예금이율은 시장금리상황에 따라 변동이 있을수 있습니다."
          )
        ])
      ]),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [_vm._v("통화 : USD")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(연이율, 세전, 단위 : %)")
      ]),
      _c("table", { staticClass: "table -type01" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { staticClass: "division", attrs: { scope: "col" } }),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v(" $5,000 "),
              _c("em", [_vm._v("이상")])
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v(" $10,000 "),
              _c("em", [_vm._v("이상")])
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v(" $50,000 "),
              _c("em", [_vm._v("이상")])
            ]),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v(" $100,000 "),
              _c("em", [_vm._v("이상")])
            ])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(" 31 "),
              _c("em", [_vm._v("일")])
            ]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".40")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".00")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(" 61 "),
              _c("em", [_vm._v("일")])
            ]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".40")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".30")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".30")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(" 92 "),
              _c("em", [_vm._v("일")])
            ]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".80")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".30")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(" 183 "),
              _c("em", [_vm._v("일")])
            ]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".60")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".00")])])
          ])
        ])
      ]),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [_vm._v("· 중도해지 : 약정이율 -2% 또는 0%")]),
        _c("p", [_vm._v("· 만기이후이율 : 약정이율 ÷ 2")]),
        _c("p", [
          _vm._v(
            "· 모든 예금이율은 시장금리상황에 따라 변동이 있을수 있습니다."
          )
        ])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("가입방법")]),
        _c("p", [_vm._v("영업점가입, 인터넷 가입")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("가입시 필요서류")]),
        _c("p", [_vm._v("신분증 (여권 또는 NZ운전면허증), 주소지 증명서 등")]),
        _c("p", [
          _vm._v("※ 기타 자세한 필요서류는 영업점으로 문의하시기 바랍니다.")
        ])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("유의사항 및 기타")]),
        _c("p", [_vm._v("- 만기지급식")]),
        _c("p", [
          _vm._v(
            "- 월이자지급식 (NZD 예금만 가능하며, 영업점에서만 신규가 가능합니다.)"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("PERSONAL TERM DEPOSIT")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          "A savings account that allows you to build your savings by making a term deposit for the fixed period of time."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "text" }, [_vm._v("Up to")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v("4.80%")]),
      _c("div", { staticClass: "etc" }, [
        _vm._v("p.a(Refer to information below)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("Types")]),
        _c("dd", [_vm._v("Term Deposit")]),
        _c("dt", [_vm._v("About the products")]),
        _c("dd", [
          _vm._v(
            "A savings account that allows you to build your savings by making a term deposit for the fixed period of time."
          )
        ]),
        _c("dt", [_vm._v("Eligibilty")]),
        _c("dd", [_vm._v("Personal customers")]),
        _c("dt", [_vm._v("Contract Terms")]),
        _c("dd", [
          _vm._v(" NZD : From 7 days to 5 years "),
          _c("br"),
          _vm._v(
            "USD : 31 days, 61 days, 92 days, 183 day (1 month, 2 months, 3 months, 6 months)"
          ),
          _c("br"),
          _c("p", { staticStyle: { color: "red" } }, [
            _vm._v(
              "For enquiries on 12 Months exceed deposit products, please contact the branch."
            )
          ])
        ]),
        _c("dt", [_vm._v("Available currency")]),
        _c("dd", [_vm._v("NZD, USD")]),
        _c("dt", [_vm._v("Deposit amount")]),
        _c("dd", [
          _vm._v(" Over NZD 5,000.00 "),
          _c("br"),
          _vm._v("Over USD 5,000.00 ")
        ]),
        _c("dt", [_vm._v("Rates")]),
        _c("dd", [
          _vm._v(" The agreed interest rate "),
          _c("br"),
          _vm._v("Currency : NZD ")
        ])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(annual interest rate, pretax, unit : %)")
      ]),
      _c("table", { staticClass: "table -type01" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [_vm._v("Term Deposit")]),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $5,000")]),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $10,000")]),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $50,000")]),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $100,000")])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(" 7D~less "),
              _c("em", [_vm._v("1M")])
            ]),
            _c("td", [_vm._v(" 0 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 0 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 0 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 0 "), _c("em", [_vm._v(".00")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("1M")]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".10")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("2M")]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".10")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".20")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("3M")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".60")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("4M")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".60")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("5M")]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".10")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".10")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".10")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("6M")]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".50")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".60")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".60")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".80")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("9M")]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".40")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".50")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".50")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".60")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("1Y")]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".10")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".20")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".30")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("2Y")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("3Y")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("4Y")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("5Y")]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".90")])])
          ])
        ])
      ]),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [_vm._v("· Early withdrawals : an agreed rate -2% or 0%")]),
        _c("p", [_vm._v("· After maturity date : agreed interest rate / 2")]),
        _c("p", [
          _vm._v(
            "· All savings interest rates are subject to change according to market interest rate trends."
          )
        ])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [_vm._v("Currency : USD")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(annual interest rate, pretax, unit : %)")
      ]),
      _c("table", { staticClass: "table -type01" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { staticClass: "division", attrs: { scope: "col" } }),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $5,000")]),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $10,000")]),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $50,000")]),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("Over $100,000")])
          ])
        ]),
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(" 31 "),
              _c("em", [_vm._v("Days")])
            ]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".40")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".00")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(" 61 "),
              _c("em", [_vm._v("Days")])
            ]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".40")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".30")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".30")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(" 92 "),
              _c("em", [_vm._v("Days")])
            ]),
            _c("td", [_vm._v(" 2 "), _c("em", [_vm._v(".80")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".30")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".70")])])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v(" 183 "),
              _c("em", [_vm._v("Days")])
            ]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 3 "), _c("em", [_vm._v(".60")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".00")])]),
            _c("td", [_vm._v(" 4 "), _c("em", [_vm._v(".00")])])
          ])
        ])
      ]),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [_vm._v("· Early withdrawals : an agreed rate -2% or 0%")]),
        _c("p", [_vm._v("· After maturity date : agreed interest rate / 2")]),
        _c("p", [
          _vm._v(
            "· All savings interest rates are subject to change according to market interest rate trends."
          )
        ])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("How to apply")]),
        _c("p", [_vm._v("Apply at the branch, Apply Online")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Required documents for application")]),
        _c("p", [_vm._v("Passport or NZ driver's licence & proof of address")]),
        _c("p", [
          _vm._v(
            "※ Please contact our branch for more detailed information on required documents."
          )
        ])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Notices and others")]),
        _c("p", [_vm._v("- At Maturity Only on Internet Banking")]),
        _c("p", [
          _vm._v(
            "- Monthly interest rate payment type (Only deposits in NZD is possible and only at the branch.)"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }